import vegaEmbed from "vega-embed"
import Formatters from "../formatters"

// Translation helper - looks up key in server-provided translations
function t(key) {
  return window.I18n?.[key] || key
}

export const BarGraph = {
  mounted() {
    this.boundHandleResize = this.handleResize.bind(this)
    window.addEventListener("resize", this.boundHandleResize)
    this.updated()
  },

  updated() {
    const { plotSpec, currencySymbol } = this.el.dataset
    if (!currencySymbol) {
      throw new Error(
        "Currency symbol is required. Currency symbols must be passed from backend based on deal/account currency.",
      )
    }
    const formatCurrency = Formatters.currencyFormatter(currencySymbol, {
      accounting: true,
    })

    this.viewPromise?.then((result) => {
      result.finalize()
    })

    this.viewPromise = vegaEmbed(`#${this.el.id}`, JSON.parse(plotSpec), {
      actions: false,
      // With the default canvas renderer, the plot can't resize to smaller size.
      // Even the project wants to change it, Ref: https://github.com/vega/vega-embed/issues/411
      renderer: "svg",
      tooltip: {
        // Custom tooltip formatting
        formatTooltip: (value, sanitize) => {
          if (!value || typeof value !== "object")
            return sanitize(String(value))

          // Build custom tooltip HTML
          let html =
            '<div style="padding: 10px; font-family: sans-serif; font-size: 13px; line-height: 1.6;">'

          if (value.tooltip_period) {
            html += `<div style="margin-bottom: 8px; font-weight: 600; border-bottom: 1px solid #ddd; padding-bottom: 6px;">${sanitize(value.tooltip_period)}</div>`
          }

          if (value.tooltip_total !== undefined) {
            html += `<div style="margin-bottom: 8px; font-weight: 600; font-size: 14px;">${t("Total:")} ${formatCurrency(value.tooltip_total)}</div>`
          }

          const lineItem = (label, val) => {
            if (val === undefined || val === null || val === 0) return ""
            return `<div style="margin-bottom: 4px;">${t(label)} ${formatCurrency(val)}</div>`
          }

          html += '<div style="margin-top: 8px;">'
          html += lineItem("Base Rent:", value.tooltip_base_rent)
          html += lineItem("Rent Abatement:", value.tooltip_rent_abatement)
          html += lineItem(
            "Operating Expenses:",
            value.tooltip_operating_expenses,
          )
          html += lineItem("TI/Concessions:", value.tooltip_ti_concessions)
          html += lineItem("TI Loan Payment:", value.tooltip_amortized_ti)
          html += lineItem("Utilities:", value.tooltip_utilities)

          html += "</div></div>"
          return html
        },
      },
    })
  },

  destroyed() {
    window.removeEventListener("resize", this.boundHandleResize)

    this.viewPromise?.then((result) => {
      result.finalize()
      this.el.remove()
    })
  },

  handleResize() {
    this.updated()
  },
}
